<template>
  <ColorPickerView
    class="color-picker-wrap"
    :color="color"
    :disableUpdateBaseColor="disableUpdateBaseColor"
    @change="handleEmitEvent"
  />
</template>

<script>
import ColorPickerView from '@/components-v2/presentation-editor/side-right/right-nav/ColorPickerView.vue'
import ColorPicker from '@/components/presentations/ColorPicker.vue'

export default {
  name: 'ColorPickerWrap',
  components: {
    ColorPickerView,
  },
  mixins: [ColorPicker],
  props: {
    color: {
      type: String,
      default: null,
    },
    disableUpdateBaseColor: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ignoreColorPickerMounted: true,
    }
  },
  created() {
    if (this.$options.mixins) {
      this.$options.mixins.forEach((mixin) => {
        if (mixin.watch && mixin.watch.baseColour) {
          delete mixin.watch.baseColour
        }
      })
    }
  },
  methods: {
    handleEmitEvent(color) {
      if (this.$listeners.change) {
        this.$emit('change', color)
        return
      }
      this.updateSlide({ baseColour: color })
    },
  },
}
</script>

<style lang="scss" scoped>
.color-picker {
  @apply w-6 h-6 rounded-full border-secondary-20 border-2;
  appearance: none;
  border-style: solid;
  -webkit-appearance: none;
  overflow: hidden;
  padding: 0;
  cursor: pointer;
}
.color-picker-wrap {
  border: 1px solid #D3D7E1;
  border-radius: 8px;
  padding: 7px;

  &:hover {
    @apply border-primary-90;
  }
  ::v-deep {
    .pickr-container{
      &.active {
        .pickr .pcr-button {
          width: 24px;
          height: 24px;
          border-radius: 100%;
          border: 1px solid #D3D7E1 !important;
          box-shadow: none !important;
        }
      }
    }
    .pickr {
      .pcr-button {
        &::before {
          border-radius: 100%;
        }
        &::after {
          border-radius: 100%;
        }
        &:focus-visible {
          outline: 2px solid;
          outline-offset: 0px;
          outline-color: #89BEFA;
        }
      }
    }
  }
}
</style>
